module.exports = __webpack_public_path__ + "static/media/er.c9799558.svg";